var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper,on:{"click":function($event){return _vm.clicked()}}},[_c('reload-icon',{staticStyle:{"margin-right":"8px"}}),_c('span',[_vm._v(_vm._s(_vm.$t("define.neueVorschlaege")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }